import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/naq6.jpeg";
import sandDredgingImage from "../../assets/naq1.jpeg";
import missionImage from "../../assets/naq4.jpeg";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/naq6.jpeg";
import chysonImg from "../../assets/naq1.jpeg";
import farmImg from "../../assets/naq2.jpeg";
import consultancyImg from "../../assets/naq2.jpeg";
import consultancy2Img from "../../assets/naq3.jpeg";
import consultancy3Img from "../../assets/naq4.jpeg";
import consultancy4Img from "../../assets/naq5.jpeg";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const NAQsTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: chysonImg, caption: "Agricultural Training" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Group-based Workshops
                    </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
From 1st to 3rd July, 2021, NAQS facilitated a community sensitization and training in Ainu Community of Oju local government area of Benue State. Here, members and leaders of some farmers groups were trained on how to turn their production of Orange fleshed sweet potato into a profitable and sustainable business.  They were also empowered with the planting materials. 
          </p>
                    <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Here, members and leaders of some farmers groups were trained on how to turn their production of Orange fleshed sweet potato into a profitable and sustainable business.  They were also empowered with the planting materials.
 </p>
        </div>
        <div className="md:w-1/2">
          <img src={sandDredgingImage} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    rural: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Sustainable Farming Focus
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
         Emphasis on eco-friendly inputs, crop rotation, and organic fertilization to preserve the environment and community health.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy2Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    health: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Community Field Visits
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Field exposures to local farms and cooperatives implementing emerging technologies or climate-smart practices.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={trainingImg} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
           Hands-on Demonstrations
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Field exercises covering soil prep, planting, irrigation, and harvest—all practiced on live demonstration plots.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy3Img} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    knowledge: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            NAQS Training: Expert & Peer Mentorship
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Learn directly from agronomists and seasoned farmers, exchanging ideas around crop management and productivity.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Knowledge Sharing" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="Ainu Oju Training" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Group-based Workshops             </button>

          <button
            onClick={() => setActiveTab("rural")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "rural" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Sustainable Farming Focus
                 </button>
               
          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Hands-on Demonstrations          </button>
          <button
            onClick={() => setActiveTab("knowledge")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "knowledge" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Expert & Peer Mentorship
          </button>
         
            <button
            onClick={() => setActiveTab("health")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "health" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Community Field Visits
                 </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="AINU OJU BENUE TRAINING — ROOTED IN COMMUNITY, POWERED BY PURPOSE" />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
              Discover a hands-on training program inspired by the rural empowerment model of the Shabu Training, tailored to the Ainu Oju Benue initiative—focused on building sustainable agricultural skills in vibrant communities.</p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
              This training program is designed to equip participants with practical skills in orange-fleshed sweet potato (OFSP) farming, enhancing food security and nutrition in their communities. Through hands-on workshops and expert-led sessions, participants learn sustainable agricultural practices that empower them to become leaders in their local agricultural sectors.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="Ainu Oju Training Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
                onClick={() => setModal({ img, caption })}
              >
                <img src={img} alt={caption} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-lg font-bold">{caption}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default NAQsTraining;
